import i18n from '@/i18n';
import { DateFormats } from '@/system-settings/enums';
import { resolveDateLocale } from '@/utils/date/date-locale';
import moment from 'moment';
import React from 'react';

type FormatDateProps = {
  date: string | Date | undefined;
  format?: string;
  locale?: string;
};

export const FormatDate: React.FC<FormatDateProps> = ({
  date,
  format = DateFormats.DATEONLY,
  locale,
}) => {
  if (!date) {
    return null;
  }

  // By default moment will convert to the local borwser time
  return (
    <>
      {moment(date)
        .locale(locale ?? resolveDateLocale(i18n.language))
        .format(format)}
    </>
  );
};
